import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { makeStyles } from '@mui/styles';
import { useTheme } from 'next-themes';
import { InputLabel, Typography } from '@mui/material';
import { ArrowDropDown, VerifiedUser } from '@mui/icons-material';

export default function CustomSelect({
  options,
  handleChange,
  selectedOption = '',
  topLabel,
  error = false,
  name,
  style,
  dropdownPlaceholder,
  placeholder,
  selectIcon,
  ...props
}) {
  const { theme } = useTheme();

  const useStyles = makeStyles({
    root: {
      width: '100%',
      backgroundColor: theme === 'dark' ? '#2D2D39' : '#f5f5f7',
      color: theme === 'dark' ? 'white' : '#252530',
      '& .MuiFormLabel-root': {
        color: theme === 'dark' ? 'white' : '#505876',
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme === 'dark' ? '#f5f5f7 ' : '#EBEBEF',
      },
    },
    // paperRoot: {
    //   backgroundColor: theme === 'dark' ? '#2b2b37' : 'black',
    // },
    icon: {
      color: theme === 'dark' ? 'white' : '#505876',
    },
    auto: {
      padding: '15px ',
      fontSize: '14px',
      fontWeight: '600',
      color: theme === 'dark' ? 'white ' : ' #505876 ',
      border: '0',
      fontFamily: 'Montserrat, sans-serif',
    },
    menuItem: {
      fontFamily: 'Montserrat, sans-serif',
    },
    outline: {
      border: '0',
      color: theme === 'dark' ? 'white' : '#505876',
    },
  });
  const classes = useStyles();

  const [opt, setOpt] = useState(selectedOption);

  useEffect(() => {
    setOpt(selectedOption);
  }, [selectedOption]);

  return (
    <>
      {topLabel ? (
        <div className='font-bold pb-2 dark:text-white text-custom-font-color'>
          {topLabel}
        </div>
      ) : null}

      <FormControl className={classes.root}>
        {!opt ? (
          <InputLabel variant='filled' shrink={false}>
            {dropdownPlaceholder || 'Select'}
          </InputLabel>
        ) : null}
        <Select
          error={error}
          value={opt}
          onChange={handleChange}
          name={name}
          displayEmpty
          placeholder={placeholder}
          inputProps={{ 'aria-label': 'Without label' }}
          classes={{
            select: classes.auto,
            outlined: classes.outline,
            icon: classes.icon,
          }}
          IconComponent={() => selectIcon || <ArrowDropDown />}
          variant='outlined'
          sx={style}
          {...props}
        >
          {!options?.length ? (
            <Typography textAlign='center'>Nothing to show</Typography>
          ) : (
            options?.map((option) => (
              <MenuItem
                classes={{ root: classes.menuItem }}
                value={option}
                defaultValue='select'
              >
                {option?.label || option?.name || option}
              </MenuItem>
            ))
          )}
        </Select>
      </FormControl>
    </>
  );
}

CustomSelect.propTypes = {
  options: PropTypes.array,
  handleChange: PropTypes.func,
  selectedOption: PropTypes.object,
  topLabel: PropTypes.string,
  name: PropTypes.string,
  error: PropTypes.bool,
  style: PropTypes.object,
  dropdownPlaceholder: PropTypes.string,
  placeholder: PropTypes.string,
  selectIcon: PropTypes.element,
};
